import * as React from "react";
const SvgImport = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={13}
    height={13}
    fill="none"
    {...props}
  >
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M12.5.5 7.58 5.42M7.1 3.002V5.9h2.898M5.9.5H4.7C1.7.5.5 1.7.5 4.7v3.6c0 3 1.2 4.2 4.2 4.2h3.6c3 0 4.2-1.2 4.2-4.2V7.1"
    />
  </svg>
);
export default SvgImport;
